export default __webpack_public_path__ + "static/media/newSubscription.8e4fdc1d.svg";